import { useEffect, useState } from "react";
import { resolveAssetUrl } from "@/lib/api";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ images, openIndex, onClose }) {
  const [idx, setIdx] = useState(openIndex || 0);

  useEffect(() => setIdx(openIndex || 0), [openIndex]);

  useEffect(() => {
    if (openIndex == null) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") setIdx((i) => (i + 1) % images.length);
      if (e.key === "ArrowLeft") setIdx((i) => (i - 1 + images.length) % images.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [openIndex, images, onClose]);

  if (openIndex == null || !images?.length) return null;

  return (
    <div
      className="fixed inset-0 z-[60] lb-overlay grid place-items-center p-6"
      onClick={onClose}
      data-testid="lightbox-overlay"
    >
      <button
        className="absolute top-6 right-6 text-white/80 hover:text-white"
        onClick={onClose}
        data-testid="lightbox-close"
      >
        <X className="w-7 h-7" />
      </button>
      <button
        className="absolute left-6 text-white/70 hover:text-white"
        onClick={(e) => { e.stopPropagation(); setIdx((i) => (i - 1 + images.length) % images.length); }}
        data-testid="lightbox-prev"
      >
        <ChevronLeft className="w-10 h-10" />
      </button>
      <img
        src={resolveAssetUrl(images[idx])}
        alt=""
        className="max-h-[88vh] max-w-[88vw] object-contain rounded-xl shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      />
      <button
        className="absolute right-6 text-white/70 hover:text-white"
        onClick={(e) => { e.stopPropagation(); setIdx((i) => (i + 1) % images.length); }}
        data-testid="lightbox-next"
      >
        <ChevronRight className="w-10 h-10" />
      </button>
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/60 text-xs tracking-wider">
        {idx + 1} / {images.length}
      </div>
    </div>
  );
}
